import flagDefaultStyle from './flagDefaultStyle';
import flagStyleDecorator from './flagStyleDecorator';
import { iconStartStyleDecorator, swallowTailStyleDecorator } from './iconStyleDecorator';
const flagStyleBuilder = (theme, variant) => {
  let style = flagDefaultStyle(theme);
  style = flagStyleDecorator(variant, style, theme);
  style = {
    display: 'flex',
    '.interstate-flag-head': {
      ...style
    }
  };
  return style;
};
const iconStartFlagStyleBuilder = (variant, theme) => {
  return iconStartStyleDecorator(variant, theme);
};
const swallowTailStyleBuilder = (variant, theme) => {
  return swallowTailStyleDecorator(variant, theme);
};
export { flagStyleBuilder, iconStartFlagStyleBuilder, swallowTailStyleBuilder };